import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { useSnackbar } from 'notistack';
import Actions from '../../actions/actions';

const Messages = ({ errors_and_messages }) => {
  const { enqueueSnackbar } = useSnackbar();
  (errors_and_messages || []).forEach(({ id, message, type }, i) => {
    if (typeof message === 'string' && message.includes('czip: Zip code not found.')) {
      message = false; //'We could not locate that ZIP Code, please double check your entry and try again.';
    } else if (message === 'Validation errors occurred' && errors_and_messages?.length > 1) {
      return null;
    }
    if (message) {
      if (typeof message === 'object' && typeof message.message === 'string') {
        enqueueSnackbar(message.message, {
          autoHideDuration: message.autoHideDuration ?? 10000,
          variant: { info: 'success', error: 'warning' }[message.type ?? type],
        });
      } else {
        enqueueSnackbar(message, { autoHideDuration: 10000, variant: { info: 'success', error: 'warning' }[type] });
      }
    }
    Actions.clearErrorsAndMessages();
  });

  return <div className="messages" style={{ zIndex: 1000, width: '100%', position: 'fixed' }} />;
};

Messages.propTypes = {
  errors_and_messages: PropTypes.array,
};

export default connect((state) => {
  const { errors_and_messages } = state;
  return { errors_and_messages };
})(Messages);
